import React from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { useUI } from '../../context/UIContext';
import Header from '../common/Header';
import LoginFooter from '../common/LoginFooter';
import LoadingSpinner from '../common/LoadingSpinner';
import CookieBanner from '../common/CookieBanner';

/**
 * Layout component for authentication pages (Login, MFA, Logout).
 * Provides a centered card layout with Header and optional Footer.
 *
 * @param {Object} props
 * @param {string} props.title - Page title displayed in the card
 * @param {React.ReactNode} props.children - Page content
 * @param {boolean} props.showFooter - Whether to show the footer (default: true)
 * @param {boolean} props.showCookieBanner - Whether to show cookie banner (default: false)
 * @param {boolean} props.centerContent - Whether to center the content text (default: false)
 */
const AuthPageLayout = ({
  title,
  children,
  showFooter = true,
  showCookieBanner = false,
  centerContent = false,
}) => {
  const { isInitialized, alert, hideAlert } = useUI();

  if (!isInitialized) {
    return (
      <div className="d-flex flex-column justify-content-center min-vh-100">
        <LoadingSpinner message="Loading..." />
      </div>
    );
  }

  return (
    <div className="d-flex flex-column justify-content-center min-vh-100">
      <Container>
        <Row className="justify-content-center">
          <Col lg={6} md={8} sm={10}>
            <Card className="shadow">
              <Card.Body className={`p-4${centerContent ? ' text-center' : ''}`}>
                <Header />

                <h2 className="text-center mb-4">{title}</h2>

                {alert.show && (
                  <Alert variant={alert.type} dismissible={alert.dismissible} onClose={hideAlert}>
                    {alert.message}
                  </Alert>
                )}

                {children}

                {showFooter && (
                  <>
                    <hr className="my-4" />
                    <LoginFooter />
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {showCookieBanner && <CookieBanner />}
    </div>
  );
};

export default AuthPageLayout;